export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg font-bold text-background-50 mb-3">
              韩漫之家
            </h3>
            <p className="text-sm text-background-400 leading-relaxed">
              韩漫之家是国内领先的韩漫下载安装与离线阅读服务平台，
              提供最新韩漫APK下载、免费韩漫资源汇总及详细使用教程，
              让每一位韩漫爱好者都能随时随地离线畅享韩漫全集。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-background-400 hover:text-background-100 transition-colors">首页</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-background-100 transition-colors">热门话题</a>
              <a href="#index" className="text-sm text-background-400 hover:text-background-100 transition-colors">专题合集</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-background-100 transition-colors">常见问答</a>
              <a href="#about" className="text-sm text-background-400 hover:text-background-100 transition-colors">关于我们</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">
              合作伙伴
            </h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-background-500">韩漫汉化组联盟</span>
              <span className="text-sm text-background-500">ACG资源分享平台</span>
              <span className="text-sm text-background-500">漫画阅读APP推荐</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">
              声明
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              本站仅提供韩漫相关资源导航与使用教程，不存储任何漫画内容。
              所有韩漫资源均来自第三方平台，版权归原作者所有。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2024-2026 韩漫之家 · 韩漫下载安装与离线免费下载平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              回到顶部
            </a>
            <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}